<template>
  <v-row>
    <v-col>
      <fp-btn block class="mb-4" :primary="!isSent" :click="() => generateSms()">
        <template v-if="!isSent">{{ t.SEND_SMS_CODE }}</template>
        <template v-else>
          {{ t.SEND_AGAIN }}
          <v-icon right>mdi-redo-variant</v-icon>
        </template>
      </fp-btn>
      <fp-input
        v-if="isSent"
        :ref="smsInput"
        v-model="props.smsApiData.smsCode"
        :disabled="loading"
        :mask="mask"
        required
        autofocus-on-create
        :label="verificationCodeLabel"></fp-input>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import ClientUserApi from '@/modules/client/services/ClientUserApi';
import {SmsApiData} from '@/models/LoginData';
import getDevelopmentVerificationCode from '@/commons/services/getDevelopmentVerificationCode';
import {ref, computed} from 'vue';
import EnvironmentService from '@/env/EnvironmentService';
import {useInstance} from '@/composables/useInstance';

const props = withDefaults(defineProps<{
  label: string;
  mask: string;
  smsApiData: SmsApiData;
  additionalParams?: Record<string, string>;
}>(), {
  additionalParams: undefined,
});
const isSent = ref<boolean>(false);
const smsInput = ref<string>('smsInput');
const loading = ref<boolean>(false);
const {$errorHandler, $i18n} = useInstance();
const t = $i18n.useSmsInput;
const verificationCodeLabel = computed(() => t.VERIFICATION_CODE.replace(':', ''));
const generateSms = async() => {
  try {
    await ClientUserApi.sendSms(props.smsApiData.phone, props.additionalParams);
    isSent.value = true;
    if (EnvironmentService.Environment.isPreprodOrDev) {
      props.smsApiData.smsCode = await getDevelopmentVerificationCode(props.smsApiData.phone);
    }
  } catch (e) {
    $errorHandler(e, t.ERROR_SENDING_SMS);
  }
};
</script>

<style scoped lang="scss">
.sms-input{
  ::v-deep input {
    font-weight: 500;
    font-size: 24px;
  }
}
</style>
